import React, { useEffect, useMemo, useState } from 'react';
import { Loader2, Radio } from 'lucide-react';
import { DashboardLayout } from '../../app/layouts/DashboardLayout';
import { MEMBER_NAV } from '../../constants/nav';
import { fetchMemberSignals, Signal } from '../../features/signals/api/signals';
import { ShareButtons } from '../../components/common/ShareButtons';
import { SignalListRow } from '../../components/signals/SignalListRow';
import { SignalDetailModal } from '../../components/signals/SignalDetailModal';
import { SignalFilterBar, filterByDate, defaultDateFilter, DateFilter } from '../../components/signals/SignalFilterBar';

export default function MemberSignalsPage() {
  const [items, setItems] = useState<Signal[]>([]);
  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState<Signal | null>(null);
  const [filter, setFilter] = useState<DateFilter>(defaultDateFilter);
  const [q, setQ] = useState('');
  useEffect(() => { fetchMemberSignals().then(setItems).finally(() => setLoading(false)); }, []);

  const filtered = useMemo(() => {
    const byDate = filterByDate(items, filter);
    const qq = q.trim().toLowerCase();
    return qq ? byDate.filter((s) => s.instrument.toLowerCase().includes(qq)) : byDate;
  }, [items, filter, q]);

  return (
    <DashboardLayout navItems={MEMBER_NAV} title="Signal & Mapping">
      <div className="max-w-3xl" data-testid="member-signals-page">
        <div className="flex items-center gap-2 mb-1">
          <Radio className="w-4 h-4 text-cyan-400" strokeWidth={1.5} />
          <p className="text-xs uppercase tracking-[0.2em] text-cyan-400">Signal & Mapping</p>
        </div>
        <h2 className="text-2xl sm:text-3xl tracking-tight font-medium text-white mb-6">Signal Trading Terbaru</h2>
        {loading ? (
          <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-cyan-400 animate-spin" strokeWidth={1.5} /></div>
        ) : items.length === 0 ? (
          <div className="bg-white/[0.02] border border-white/10 rounded-2xl p-8 text-center text-white/50">Belum ada signal.</div>
        ) : (
          <>
            <SignalFilterBar value={filter} onChange={setFilter} search={q} onSearch={setQ} />
            {filtered.length === 0 ? (
              <div className="bg-white/[0.02] border border-white/10 rounded-2xl p-8 text-center text-white/50" data-testid="signal-empty-filtered">Tidak ada signal pada rentang tanggal ini.</div>
            ) : (
              <div className="space-y-3" data-testid="signal-list">
                {filtered.map((s) => (
                  <SignalListRow key={s.id} s={s} testId={`signal-row-${s.id}`} onClick={() => setDetail(s)} />
                ))}
              </div>
            )}
          </>
        )}
      </div>

      {detail && (
        <SignalDetailModal signal={detail} onClose={() => setDetail(null)}>
          <div className="mt-4 pt-4 border-t border-white/10">
            <ShareButtons url={`${process.env.REACT_APP_BACKEND_URL}/api/v1/public/signals/${detail.id}/share`} text={`Signal ${detail.instrument} ${detail.direction.toUpperCase()} @ ${detail.entry_price}`} testIdPrefix={`signal-share-${detail.id}`} />
          </div>
        </SignalDetailModal>
      )}
    </DashboardLayout>
  );
}
